/**
 *
 * AuthPage
 *
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { ApolloProvider, Mutation } from 'react-apollo';
import apolloClientToAuth from 'graphql/client/apolloClientToAuth';
import { GeneralContext } from 'context/';
import { LOGIN_USER } from '../../../graphql/mutation/users';
import messages from './messages';

let buttonRef = null;
export function AuthPage({ history }) {
  const generalContext = React.useContext(GeneralContext);
  const { setLoading, setShowMessage, setErrorMessage } = generalContext;
  const [user, setUser] = useState(null);
  const [userExist, setUserExist] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      buttonRef.click();
    }, 100);
  }, []);

  const handleStatusUpdated = data => {
    setUserExist(true);
    setUser(data);
    localStorage.removeItem('user');
    localStorage.setItem('jwt', data.loginAdNUser.jwt);
    localStorage.setItem('user', JSON.stringify(data.loginAdNUser));
    if (data.loginAdNUser.role.code_name === 'CLIENTE') {
      window.location.href = '/anticipos';
    } else {
      window.location.href = '/dashboard';
    }
    setLoading(false);
  };

  const handleStatusUpdatedError = () => {
    const { jwt } = JSON.parse(localStorage.getItem('user'));

    if (!jwt) {
      setErrorMessage(messages.inexistent_user);
      setShowMessage(true);
      setUser({});
      localStorage.removeItem('user');
      localStorage.removeItem('jwt');
    }

    history.push('/');
    setLoading(false);
  };

  return (
    <div>
      <Helmet>
        <title>AuthPage</title>
        <meta name="description" content="Description of AuthPage" />
      </Helmet>
      <ApolloProvider immutable client={apolloClientToAuth}>
        <Mutation
          onCompleted={handleStatusUpdated}
          onError={handleStatusUpdatedError}
          mutation={LOGIN_USER}
        >
          {loginUser => (
            <>
              <button
                hidden
                type="button"
                ref={ref => {
                  buttonRef = ref;
                }}
                onClick={() => {
                  loginUser({
                    variables: {
                      email: JSON.parse(localStorage.getItem('user')).email,
                    },
                  });
                }}
              >
                x
              </button>
            </>
          )}
        </Mutation>
      </ApolloProvider>
      {user && !userExist && <div>{messages.inexistent_user}</div>}
    </div>
  );
}

AuthPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default AuthPage;
